// See also https://github.com/osmberlin/parkraum.osm-verkehrswende.org/tree/main/public/project-prototype-neukoelln/data
export const translationsParkingLars = {
  'lars_parking--capacity_status--key': 'Vollständigkeit',
  'lars_parking--capacity_status=data_missing': 'Daten fehlen – bisher wurden noch keine Daten in OSM hinterlegt',
  'lars_parking--capacity_status=no_parking': 'Daten erfasst (Parken verboten)',
  'lars_parking--capacity_status=not_processed_yet': 'Daten fehlen – Prozessierung in Arbeit',
  'lars_parking--capacity_status=other': 'Daten erfasst',
  'lars_parking--capacity_status=segment_too_small': 'Daten erfasst und prozessiert aber Segment zu klein für einen Parkstand',
  'lars_parking--capacity--key': 'Stellplatzanzahl',
  'lars_parking--condition_class--key': 'Parkbeschränkungen',
  'lars_parking--highway_name--key': 'Straßenname',
  'lars_parking--highway_width_proc_effective--key': 'Nutzbare Fahrbahnbreite',
  'lars_parking--highway:name--key': 'Straßenname',
  'lars_parking--length--key': 'Länge',
  'lars_parking--markings--key': 'Markierung',
  'lars_parking--markings=no': 'Keine Straßenmarkierungen des Parkbereichs',
  'lars_parking--markings=yes': 'Parkbereich mit Straßenmarkierungen versehen',
  'lars_parking--operator_type--key': 'Rechtliche Zuordnung',
  'lars_parking--operator_type=private': 'Privat',
  'lars_parking--operator_type=public': 'Öffentlich',
  'lars_parking--orientation--key': 'Ausrichtung',
  'lars_parking--orientation=diagonal': 'Schrägparken',
  'lars_parking--orientation=no': '(!) Kein Parken',
  'lars_parking--orientation=parallel': 'Parallelparken',
  'lars_parking--orientation=perpendicular': 'Querparken',
  'lars_parking--parking--key': 'Art des Parkens',
  'lars_parking--parking=lane': 'Auf der Fahrbahn',
  'lars_parking--parking=street_side': 'Parkbucht',
  'lars_parking--position--key': 'Position',
  'lars_parking--position=half_on_kerb': 'Halb auf dem Gehweg',
  'lars_parking--position=lane': 'Auf der Fahrbahn',
  'lars_parking--position=no': 'Park- oder Halteverbot (implizit oder Beschildert)',
  'lars_parking--position=on_kerb': 'Auf dem Gehweg',
  'lars_parking--position=separate': 'Parkstand als separate Geometrie erfasst; Detailattribute bitte an der separaten Geometrie ablesen.',
  'lars_parking--position=shoulder': 'Seitenstreifen',
  'lars_parking--position=street_side': 'Parkbucht',
  'lars_parking--source_capacity--key': 'Quelle Stellplatzanzahl',
  'lars_parking--source_capacity=estimated': 'Interpolation',
  'lars_parking--source_capacity=OSM': 'Explizit in OSM erfasst',
  'lars_parking--surface--key': 'Oberfläche',
  'lars_parking--title': 'Parkraum [Community]',
  'lars_parking_areas--access--key': 'Zugang',
  'lars_parking_areas--access=customers': 'Kund:innen',
  'lars_parking_areas--access=destination': 'Anlieger frei (Nicht-Durchgangsverkehr erlaubt)',
  'lars_parking_areas--access=no': 'Beschränkt',
  'lars_parking_areas--access=permissive': 'Geduldet',
  'lars_parking_areas--access=private': 'Privat',
  'lars_parking_areas--access=yes': 'Öffentlich',
  'lars_parking_areas--building--key': 'Gebäudeart',
  'lars_parking_areas--building=carport': 'Carport',
  'lars_parking_areas--building=garage': 'Garage',
  'lars_parking_areas--building=garages': 'Garagen',
  'lars_parking_areas--building=parking': 'Parkhaus',
  'lars_parking_areas--building=supermarket': 'Supermarkt',
  'lars_parking_areas--capacity--key': 'Kapazität (Explizit, OSM)',
  'lars_parking_areas--description--key': 'Freitextnotizen aus OSM',
  'lars_parking_areas--fee--key': 'Gebühr',
  'lars_parking_areas--fee=no': 'Keine Gebühr',
  'lars_parking_areas--fee=yes': 'Geführenpflichtig',
  'lars_parking_areas--markings--key': 'Markierung',
  'lars_parking_areas--operator_type--key': 'Betreiber (Kategorie)',
  'lars_parking_areas--operator--key': 'Betreiber',
  'lars_parking_areas--orientation--key': 'Ausrichtung',
  'lars_parking_areas--orientation=diagonal': 'Schrägparken',
  'lars_parking_areas--orientation=parallel': 'Parallelparken',
  'lars_parking_areas--orientation=perpendicular': 'Querparken',
  'lars_parking_areas--parking--key': 'Art',
  'lars_parking_areas--parking=carport': 'Carport',
  'lars_parking_areas--parking=carports': 'Carport',
  'lars_parking_areas--parking=garage_boxes': 'Garagen',
  'lars_parking_areas--parking=lane': 'Parken auf der Fahrbahn',
  'lars_parking_areas--parking=multi-storey': 'Parkhaus',
  'lars_parking_areas--parking=rooftop': 'Dachebene',
  'lars_parking_areas--parking=street_side': 'Parkbucht/Parktasche/Parkhafen',
  'lars_parking_areas--parking=surface': 'Flächenparkplatz',
  'lars_parking_areas--parking=underground': 'Tiefgarage',
  'lars_parking_areas--surface--key': 'Oberfläche',
  'lars_parking_areas--title': 'Parkplatz-Flächen [Community]',
  'lars_parking_stats--admin_level--key': 'Grenzen Level',
  'lars_parking_stats--d_other_km--key': 'Straßen-km "Sonstiges"',
  'lars_parking_stats--done_percent--key': 'Stand Erfassung Parkraum',
  'lars_parking_stats--half_on_kerb_km--key': 'Straßen-km parken halb auf dem Gehweg',
  'lars_parking_stats--lane_km--key': 'Straßen-km parken auf der Fahrbahn',
  'lars_parking_stats--length_wo_dual_carriageway--key': 'Straßen-km (alle Attribute) ohne Filterung von zweispurig erfassten Fahrbahnen ("dual_carriageway")',
  'lars_parking_stats--on_kerb_km--key': 'Straßen-km parken auf dem Gehweg',
  'lars_parking_stats--street_side_km--key': 'Straßen-km parken in Parkbuchten',
  'lars_parking_stats--sum_km--key': 'Straßen-km (alle Attribute)',
  'lars_parking_stats--title': 'Statisik zum Parkraum [Community]',
}
